import { Check } from 'lucide-react';
import type { CreateBookingResult } from '@flyingmuse/shared';

export function SuccessStep({
  result,
  email,
  onClose,
}: {
  result: CreateBookingResult;
  email: string;
  onClose: () => void;
}) {
  return (
    <div className="py-4 text-center">
      <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-crimson/10">
        <Check className="h-7 w-7 text-crimson" strokeWidth={2.2} />
      </div>

      <h3 className="mt-5 font-display text-2xl font-medium text-charcoal">
        You&rsquo;re booked!
      </h3>
      <p className="mx-auto mt-2 max-w-sm font-sans text-sm font-light leading-relaxed text-stone">
        Your reservation is confirmed. A confirmation email is on its way to{' '}
        <span className="font-medium text-charcoal">{email}</span>. We&rsquo;ll be
        in touch to finalise your start time and pick-up.
      </p>

      <div className="mx-auto mt-5 inline-block rounded-lg border border-charcoal/15 bg-cream-soft px-5 py-3">
        <p className="font-sans text-[0.62rem] font-semibold uppercase tracking-label text-charcoal/55">
          Booking reference
        </p>
        <p className="mt-1 font-display text-xl font-medium tracking-wide text-charcoal">
          {result.bookingCode}
        </p>
      </div>

      <p className="mt-5 font-sans text-xs font-light text-stone">
        Remember: payment is made in person on the day.
      </p>

      <button
        type="button"
        onClick={onClose}
        className="btn btn-primary mt-7"
      >
        Done
      </button>
    </div>
  );
}
